// src/components/pages/dialogs/AnulationReasonDialog.tsx

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { anularCita } from '@/components/hooks/useCitas';
import { DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';

export type AnulationReasonDialogProps = {
  idCita: string;
  motivo: string;
  setMotivo: (valor: string) => void;
  open: boolean;
  onCancel: () => void;
  onCloseAll: () => void;
  incrementReload: () => void;
};

const AnulationReasonDialog = ({
  idCita,
  motivo,
  setMotivo,
  open,
  onCancel,
  onCloseAll,
  incrementReload,
}: AnulationReasonDialogProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);

    const resp = await anularCita(idCita, motivo);

    setLoading(false);

    if (resp.ok) {
      toast.success(t('anulationReasonDialog.successToast'));
      onCloseAll();
      incrementReload();
    } else {
      toast.error(t('anulationReasonDialog.errorToast'));
    }
  };

  return (
    <>
      {/* Contenedor interno */}
      <div className="rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4 mt-1 space-y-5 text-sm text-gray-700 dark:text-gray-300">
        <div>
          <label className="block font-medium mb-1 text-gray-700 dark:text-gray-300">
            {t('anulationReasonDialog.placeholder')}
          </label>
          <Textarea
            rows={4}
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder={t('anulationReasonDialog.placeholder')}
            className="resize-none rounded-md border-gray-300 dark:border-white/10 bg-white dark:bg-white/5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500"
          />
        </div>
      </div>

      <DialogFooter className="mt-6 flex flex-col sm:flex-row sm:justify-end gap-3">
        {/* Volver */}
        <Button
          onClick={onCancel}
          disabled={loading}
          variant="outline"
          className="w-full sm:w-auto rounded-lg font-medium bg-transparent dark:bg-transparent border-gray-300 dark:border-white/10 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors"
        >
          {t('anulationReasonDialog.back')}
        </Button>

        {/* Confirmar */}
        <Button
          onClick={handleConfirm}
          disabled={loading}
          className="w-full sm:w-auto rounded-xl text-white font-semibold text-base shadow-md bg-yellow-500 hover:bg-yellow-600 dark:bg-yellow-600 dark:hover:bg-yellow-700 py-3 disabled:opacity-50 transition-colors"
        >
          {loading
            ? t('anulationReasonDialog.confirming')
            : t('anulationReasonDialog.confirm')}
        </Button>
      </DialogFooter>
    </>
  );
};

export default AnulationReasonDialog;